export default {
  Blue: '#178AF7',
  Indigo: '#4E1CDC',
  Violet: '#9933CC',
  Fuchsia: '#FF00FF',
  Pink: '#F33A6A',
  Black: '#000000',
  Teal: '#40E0D0',
  DarkGreen: '#00A36C',
  LightGreen: '#90EE90',
  Yellow: '#FFD300',
  Orange: '#F29D39',
  Red: '#EB3323',
  White: '#FFFFFF',
  LightGray: '#D9D9D9',
  DarkGray: '#888888'
};
